export default __webpack_public_path__ + "static/media/img_membership-kv.c9ac2a59.png";